<template>
  <div class="page--crud">
    <div>
      <h3 class="title">Monitoramento de pedido Zepplin</h3>
      <app-company-request-monitoring-filter
        ref="filter"
        :loading="loading"
        @clean-selection="selectedItems = []"
        @search="search($event)"
      ></app-company-request-monitoring-filter>
      <app-grid
        ref="grid"
        v-model="selectedItems"
        :noSelection="true"
        :columns="columns"
        :rows="rows"
        :total="totalItems"
        :loading="loading"
      >
        <div class="summary" style="display: flex; justify-content: center; align-items: center">
          <div>
            <app-pagination
              :currentPage="currentPage"
              :totalPages="getTotalPages"
              @pagechanged="onPageChange"
            ></app-pagination>
          </div>
        </div>
        <template slot="actions" slot-scope="slotProps">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <div class="iconDIV">
              <a href="javascript:void(0)" class="edit-row" @click.stop="recover(slotProps.row.id)">
                <icon-edit></icon-edit>
              </a>
            </div>
            <div
              class="iconDIV"
              v-if="slotProps.row.payload && slotProps.row.payload.company.phoneNumber"
            >
              <a
                href="javascript:void(0)"
                class="edit-row"
                @click.stop="redirectWhatsApp(slotProps.row.payload.company.phoneNumber)"
              >
                <icon class="SVGicon" name="whatsapp" width="14" height="14" color="#ccc" />
              </a>
            </div>
            <div class="iconDIV">
              <a
                href="javascript:void(0)"
                class="edit-row"
                @click.stop="openTransactions(slotProps.row)"
              >
                <icon class="SVGicon" name="credit-card" width="18" height="18" />
              </a>
            </div>
          </div>
        </template>
      </app-grid>

      <div class="footer"></div>
    </div>
    <app-modal
      v-if="showTransactionsModal"
      @close="showTransactionsModal = false"
      :noActionButton="true"
      @action="submit()"
    >
      <template slot="header">
        <div style="margin-right: 20px; color: #C3C5C6;">TRANSAÇÕES DO PEDIDO Nº {{ request.code }}</div>
      </template>
      <template slot="body">
        <div v-if="request.transactions.length">
          <table>
            <thead>
              <tr style="display: flex; justify-content: space-between; width: 100%;">
                <th style="width: 200px;">TID</th>
                <th style="width: 200px;">Tipo</th>
                <th style="width: 200px;">Cartão</th>
                <th style="width: 200px;">Valor</th>
                <th style="width: 200px;">Status</th>
                <th style="width: 200px;"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="transaction of request.transactions"
                :key="transaction.id"
                style="display: flex; justify-content: space-between; width: 100%;"
              >
                <td style="width: 200px; text-align: center;">{{ transaction.tid }}</td>
                <td
                  style="width: 200px; text-align: center;"
                >{{ transaction.type === 'payment' ? 'PAGAMENTO' : 'ESTORNO' }}</td>
                <td
                  style="width: 200px; text-align: center;"
                >{{ `${transaction.rede.authorization.last4} - ${transaction.rede.authorization.kind.toLowerCase() == 'credit' ? 'Crédito' : 'Débito'}` }}</td>
                <td
                  style="width: 200px; text-align: center;"
                >{{ utils.formatMoney((transaction.rede.authorization.amount / 100), 2, 'R$', '.', ',') }}</td>
                <td
                  style="width: 200px; text-align: center;"
                >{{ handleTransactionStatus(transaction.rede.authorization.status) }}</td>
                <td style="width: 200px; display: flex; justify-content: center;">
                  <button
                    v-if="transaction.type === 'payment' && transaction.rede.authorization.status !== 'Canceled'"
                    class="btn"
                    @click="refund(transaction.requestId)"
                  >Estornar</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>Pagamento na entrega</div>
      </template>
    </app-modal>
  </div>
</template>
<script>
import { mapGetters, mapState, mapActions } from "vuex";

import utils from "../../../utils/index";
import moment from "moment";
import _ from "lodash";
import shortid from "shortid";

import Request from "../../../vuex/models/Request";

import RequestsAPI from "../../../api/requests";
import ZepplinRequestsAPI from "../../../api/zepplin/requests";
import CompanyRequestMonitoringFilterComponent from "./CompanyRequestMonitoringFilter.vue";
import { GridCore } from "../../../components/Utilities/Grid/index";
import { Portuguese } from "flatpickr/dist/l10n/pt";
import PaginationComponent from "../../../components/Utilities/Pagination.vue";

export default {
  components: {
    "app-company-request-monitoring-filter": CompanyRequestMonitoringFilterComponent,
    "app-grid": GridCore,
    "app-pagination": PaginationComponent
  },
  data() {
    return {
      logoSrc: require("../../../assets/imgs/logo-2018.png"),
      filterData: [],
      currentPage: 1,
      offset: 0,
      limit: 50,
      totalItems: 0,
      totalAmount: 0,
      totalZepplinTax: 0,
      selectedItems: [],
      rows: [],
      columns: [
        {
          text: "Tempo decorrido",
          name: "time",
          width: 130
        },
        {
          text: "Pedido criado",
          name: "requestDateCreated",
          width: 130
        },
        {
          text: "Nº",
          name: "id",
          width: 80,
          style: {
            "justify-content": "center"
          }
        },
        {
          text: "Tel. Empresa",
          name: "companyPhoneNumber",
          width: 140
        },
        {
          text: "Empresa",
          name: "company",
          width: 130
        },
        {
          text: "Nome",
          name: "name"
        },
        {
          text: "Status",
          name: "status",
          width: 160,
          style: {
            "justify-content": "center"
          }
        },
        {
          text: "Ações",
          name: "actions",
          style: {
            "justify-content": "center"
          },
          width: 72
        }
      ],
      filterForm: {
        dateCreated: [[]],
        dateCreatedToSend: [[]],
        search: null
      },
      loading: true,
      datetimeSelectorConfig: {
        altInput: true,
        altFormat: "d/m/Y H:i:S",
        dateFormat: "Z",
        locale: Portuguese,
        time_24hr: true,
        enableTime: true
      },
      request: null,
      showTransactionsModal: false
    };
  },
  computed: {
    ...mapState("auth", ["company", "user", "zepplinMasterToken"]),
    ...mapState("data/request-status", ["requestStatusList"]),
    ...mapGetters("data/request-status", [
      "requestStatusListSelectItems",
      "getRequestStatusByValue"
    ]),
    accountsSelectItems() {
      return _.map(this.accounts, account => {
        return {
          value: account.id,
          text: account.name
        };
      });
    },
    getTotalPages() {
      return this.totalItems <= this.limit
        ? 1
        : (!Number.isInteger(this.totalItems / this.limit)
            ? Math.trunc(this.totalItems / this.limit)
            : this.totalItems / this.limit - 1) + 1;
    }
  },
  methods: {
    ...mapActions("draft/request", ["runRequestRecoverance"]),
    ...mapActions("toast", ["showToast", "showError"]),
    ...mapActions("loading", ["startLoading", "stopLoading", "setLoadingText"]),

    redirectWhatsApp(phoneNumber) {
      window.open("https://wa.me/55" + phoneNumber);
    },

    async recover(requestId) {
      const vm = this;
      try {
        let request = await RequestsAPI.getOne(requestId);
        request = request.data;

        const requestDenormalized = this.VXORM.STATE_Request.denormalizeRequest(
          request,
          request.status,
          false,
          true,
          true
        );
        let STATE_request = this.VXORM.STATE_Request.query()
          .where("requestId", requestId)
          .first();

        if (_.get(request, "requestOrder.requestOrderProducts")) {
          request.requestOrder.requestOrderProducts.forEach(
            requestOrderProduct => {
              this.VXORM.Product.insert({ data: requestOrderProduct.product });
            }
          );
        }
        if (_.get(request, "requestOrder.requestOrderPayments")) {
          request.requestOrder.requestOrderPayments.forEach(
            requestOrderPayment => {
              this.VXORM.PaymentMethod.insert({
                data: requestOrderPayment.paymentMethod
              });
            }
          );
        }
        if (!STATE_request) {
          const { STATE_requests } = await this.VXORM.STATE_Request.insert({
            data: requestDenormalized
          });
          STATE_request = STATE_requests[0];
        }
        STATE_request.openWindow(this);

        STATE_request.$update({
          where: STATE_request.id,
          data: {
            activeTab: "order"
          }
        });
      } catch (err) {
        console.log("Error occurred", err);
      }
    },
    search({ filterData = null, params = {} } = {}) {
      this.loading = true;
      if (filterData) this.filterData = filterData;

      this.currentPage = 1;
      this.offset = 0;

      const requestParams = {
        offset: this.offset,
        limit: this.limit,
        dateCreated: this.filterData.dateCreatedToSend,
        search: this.filterData.search
      };
      this.updateFilter(requestParams);
    },
    submit() {
      const vm = this;
      if (!vm.form.action) {
        vm.showToast({
          type: "error",
          message: "Você deve selecionar uma ação!"
        });
        return;
      }
      if (!vm.selectedItems.length) {
        vm.showToast({
          type: "error",
          message: "Você não selecionou nenhum item!"
        });
        return;
      }
    },
    onPageChange(page) {
      this.currentPage = page;
      this.offset = parseInt(`${page - 1}0`);
      let requestParams = {
        limit: this.limit,
        offset: this.offset * 5,
        dateCreated: this.filterData.dateCreatedToSend,
        search: this.filterData.search
      };
      this.updateFilter(requestParams);
    },
    updateFilter(requestParams) {
      const vm = this;

      this.loading = true;
      RequestsAPI.getRequestsWithZepplinId(requestParams).then(({ data }) => {
        console.log(data);
        vm.rows = _.map(data.rows, vm.upsertRow);
        this.totalItems = data.count;
        this.loading = false;
      });
    },
    upsertRow(row) {
      const vm = this;
      const status = this.getRequestStatusByValue(row.status);
      const timeMin =
        row.status !== "finished"
          ? moment()
              .local()
              .diff(moment(row.dateCreated).local(), "minutes")
          : moment(row.deliveredDate)
              .local()
              .diff(row.dateCreated, "minutes");
      return {
        id: row.id,
        requestId: row.id,
        zepplinId: row.zepplinId,
        code: row.code,
        columns: [
          {
            column: "time",
            text:
              row.status !== "canceled" && row.status !== "removed"
                ? timeMin + "min"
                : "---",
            style: {
              color: this.handleTimerColor(row)
            }
          },
          {
            column: "requestDateCreated",
            text: row.dateCreated
              ? moment(row.dateCreated)
                  .local()
                  .format("DD/MM HH:mm")
              : "---"
          },
          {
            column: "id",
            text: row.code,
            style: {
              "justify-content": "center"
            }
          },
          {
            column: "companyPhoneNumber",
            text: row.company.phoneNumber ? row.company.phoneNumber : "---"
          },
          {
            column: "company",
            text: row.company.name
          },
          {
            column: "name",
            text: _.get(row, "requestContact.contact.name", "---"),
            showTitle: true
          },
          {
            column: "status",
            text: status ? status.name : "---",
            style: {
              "justify-content": "center"
            }
          },
          {
            column: "actions",
            html: true,
            style: {
              "justify-content": "center"
            }
          }
        ],
        payload: {
          requestId: row.id,
          dateCreated: row.dateCreated,
          deliveryDate: row.deliveryDate,
          deliveredDate: row.deliveredDate,
          status: row.status,
          company: {
            phoneNumber: row.company.phoneNumber
          }
          // amount: row.requestOrder.requestOrderPayments[0].amount
        }
      };
    },

    handleTimerColor(request) {
      let color = null;
      if (
        request.status !== "finished" &&
        request.status !== "canceled" &&
        request.status !== "removed"
      )
        color =
          request.status !== "pending" && request.deliveryDate
            ? this.utils.getColor(
                request.dateCreated,
                moment().local(),
                false,
                moment(request.deliveryDate)
                  .local()
                  .diff(moment().local(), "minutes")
              )
            : this.utils.getColor(
                request.dateCreated,
                moment().local(),
                false,
                2
              );
      return color;
    },

    incrementTimer() {
      this.rows.forEach(row => {
        if (
          row.payload.status !== "finished" &&
          row.payload.status !== "canceled"
        ) {
          row.columns[0].text =
            moment().diff(row.payload.dateCreated, "minutes") + "min";
          row.columns[0].style.color = this.handleTimerColor(row.payload);
        }
      });
      if (!_.get(this.$refs, "grid.grid.rows")) return;

      this.$refs.grid.grid.rows = this.rows;
      setTimeout(() => this.incrementTimer(), 5000);
    },

    async openTransactions(row) {
      this.startLoading();
      try {
        const { data } = await ZepplinRequestsAPI.getTransactions(
          row.zepplinId
        );
        this.request = { code: row.code, transactions: data };
        console.log(this.request);
        this.showTransactionsModal = true;
      } catch (err) {
        console.error(err);
        this.showError("Não foi possível carregar o as transações do pedido.");
      } finally {
        this.stopLoading();
      }
    },

    handleTransactionStatus(status) {
      let formattedStatus;
      switch (status) {
        case "Approved":
          formattedStatus = "Aprovado";
          break;
        case "Denied":
          formattedStatus = "Negado";
          break;
        case "Canceled":
          formattedStatus = "Cancelado";
          break;
        case "Pending":
          formattedStatus = "Pendente";
          break;
      }
      return formattedStatus;
    },

    async refund(requestZepplinId) {
      this.startLoading();
      try {
        await ZepplinRequestsAPI.refundRequestTransaction(requestZepplinId, {
          masterToken: this.zepplinMasterToken
        });
        this.showToast({
          type: "success",
          message: "Estorno realizado com sucesso!"
        });
        this.showTransactionsModal = false;
      } catch (err) {
        console.error(err);
        this.showError("Não foi possível realizar o estorno.");
      } finally {
        this.stopLoading();
      }
    }
  },
  async mounted() {
    await this.search({});
    this.incrementTimer();
    /* this.$bus.$on("saveRequest", () => {
                this.onPageChange(this.currentPage)
            }) */
  },
  beforeDestroy() {}
};
</script>

<style lang="scss">
.page--crud {
  display: flex;
  width: 100%;
  justify-content: center;
  background-color: var(--bg-color--7);

  a.column-received {
    color: var(--font-color);
    &.active {
      color: var(--font-color--primary);
    }
    background-color: transparent;
  }

  a.edit-row {
    padding: 0 5px;
  }

  a.edit-row .colorizable {
    fill: var(--font-color);
  }

  a.edit-row:hover .colorizable {
    fill: var(--font-color--primary);
  }

  /* title */

  h3.title {
    font-size: 16px;
    text-transform: uppercase;
    color: var(--font-color--7);
  }

  /* filter */

  ul.filter-menu {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    padding-bottom: 20px;
  }
  ul.filter-menu li {
    margin: 0 5px;
    position: relative;
  }
  ul.filter-menu >>> li.datetime-selector input {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    position: absolute;
    overflow: hidden;
    z-index: -1;
  }
  ul.filter-menu li a {
    height: 32px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    color: var(--font-color--7);
  }
  ul.filter-menu li a.right-padding {
    padding-right: 30px;
  }
  ul.filter-menu li a.clear-filter {
    position: absolute;
    top: 10px;
    right: 10px;
  }
  ul.filter-menu li a .primary {
    color: var(--font-color--primary);
    font-weight: 600;
  }
  ul.filter-menu li a .dot-separator.primary {
    background-color: var(--border-color--primary);
  }
  ul.filter-menu li a .secondary {
    color: var(--font-color--secondary);
    font-weight: 600;
  }
  ul.filter-menu li a .dot-separator.secondary {
    background-color: var(--border-color--secondary);
  }
  ul.filter-menu li a .terciary {
    color: var(--font-color--terciary);
    font-weight: 600;
  }
  ul.filter-menu li a .dot-separator.terciary {
    background-color: var(--border-color--terciary);
  }

  /* summary */

  .summary {
    display: flex;
    flex-direction: row;
    flex-shrink: 0;
    padding: 20px 20px;
    border-top: 1px solid var(--bg-color--8);

    .summary__item {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      padding: 0 20px;
      border-right: 1px solid var(--bg-color--8);
    }

    .summary__item.border-left {
      border-left: 1px solid var(--bg-color--8);
    }

    .summary__item:last-child {
      border-right: 0;
    }
  }

  /* footer */

  div.footer {
    padding: 40px 0;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
  }

  div.footer a {
    text-transform: uppercase;
  }

  div.footer span {
    font-weight: 600;
  }

  div.footer .left-side {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-left: 20px;
  }

  div.footer .left-side > * {
    margin: 0 5px;
  }

  div.footer .right-side {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-right: 20px;
  }

  div.footer .right-side .group {
    border: 1px solid var(--bg-color--9);
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 0 15px;
    border-radius: 10px;
    margin-right: 10px;
    height: 32px;
  }

  div.footer .right-side > a {
    height: 30px;
  }

  div.footer .right-side .group .dot-separator {
    margin: 0 10px;
  }

  div.footer .right-side .group span {
    margin-right: 10px;
    white-space: nowrap;
  }

  div.footer .right-side > * {
    margin: 0 5px;
  }

  div.footer .right-side > *:last-child {
    margin: 0 0 0 5px;
  }
}
.page--crud > div {
  width: 96%;
  text-align: center;
  padding-top: 40px;
  display: flex;
  flex-direction: column;
}
.page--crud > div > h3 {
  padding-bottom: 30px;
}

.datetime-selector {
  margin-bottom: 0;
  border: 0;
  margin-top: 0;
  padding: 0;
  &:hover,
  &:active,
  &:focus {
    margin-bottom: 0;
    border: 0;
    margin-top: 0;
    padding: 0;
  }
}

.grid__header {
  z-index: 0 !important;
}

.iconDIV {
  margin: 0 5px;
}

.SVGicon:hover {
  svg path {
    fill: #fff;
  }
}
</style>
